import { api } from './base';

/**
 * User Preferences API
 * Manage user's UI preferences (open tabs, active conversation, etc.)
 * This is the single source of truth for tab state - localStorage is just a cache
 */
export interface UserPreferences {
  openConversationIds: string[];
  activeConversationId: string | null;
  chatPanelWidth?: number;
  defaultAiMode?: 'ask' | 'agent' | 'plan' | 'diagram';
  updatedAt: string;
}

export const userPreferencesApi = {
  get: async (): Promise<UserPreferences> => {
    const response = await api.get('/user/preferences');
    return response.data.data;
  },

  update: async (updates: Partial<Omit<UserPreferences, 'updatedAt'>>): Promise<UserPreferences> => {
    const response = await api.patch('/user/preferences', updates);
    return response.data.data;
  },
};

/**
 * User Terms Acceptance API
 */
export interface TermsStatus {
  accepted: boolean;
  currentTermsVersion: string;
  currentPrivacyVersion: string;
  termsUrl: string;
  privacyUrl: string;
  userTermsVersion?: string;
  userPrivacyVersion?: string;
  acceptedAt?: string;
}

export const userApi = {
  getTermsStatus: async (): Promise<TermsStatus> => {
    const response = await api.get('/user/terms-status');
    return response.data.data;
  },

  acceptTerms: async (termsVersion: string, privacyVersion: string): Promise<void> => {
    await api.post('/user/accept-terms', { termsVersion, privacyVersion });
  },
};
